import { computed } from "vue";
import { useFinder } from "#ce/composables/useFinder";
import { useHostElement } from "#ce/composables/useHostElement";
import { resolveFinder } from "#ce/shared/finder-association";

/**
 * Returns the enclosing finder's completed sort and search criteria.
 * `report(value)` calls its `sortBy` when available. Without a completed search, criteria come from current params.
 */
export function useFinderSortCommand() {
  const host = useHostElement();
  const finder = useFinder();

  function report(value) {
    const element = host ? resolveFinder(host).element : undefined;

    if (typeof element?.sortBy === "function") {
      element.sortBy(value);
    }
  }

  return {
    sort: computed(() => finder.completed.value?.params?.sort),
    params: computed(() => finder.completed.value?.params ?? finder.params.value),
    report,
  };
}
